import cloudflarePhoto from '@utils/links/cloudflarePhoto'

function resolveCloudflareSrcSet (object, imageId) {
    if (!object || typeof object !== 'object') return undefined
    return Object.entries(object).map(([screen, variant]) => `${cloudflarePhoto(imageId, variant)} ${screen}`).join(', ')
}

export default resolveCloudflareSrcSet